import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=304c1e98&scoped=true"
import script from "./FaqCard.vue?vue&type=script&lang=ts"
export * from "./FaqCard.vue?vue&type=script&lang=ts"
import style0 from "./FaqCard.vue?vue&type=style&index=0&id=304c1e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304c1e98",
  null
  
)

export default component.exports